import { Cancel, Search } from "@mui/icons-material";
import { InputAdornment, Portal, TextField } from "@mui/material";
import { deepPurple, grey } from "@mui/material/colors";
import {
  GridPortalWrapper,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
} from "@mui/x-data-grid";
import { FC } from "react";

const SearchBar: FC = () => {
  const container = document.getElementById("filter-panel");

  return (
    <>
      <Portal container={container}>
        <GridPortalWrapper>
          <QuickFilter expanded>
            <QuickFilterControl
              render={({ ref, ...other }) => (
                <TextField
                  {...other}
                  sx={{
                    width: 260,
                    "& .MuiInput-underline:hover:not(.Mui-disabled)::before": {
                      borderBottomColor: deepPurple[800],
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: deepPurple[800],
                    },
                    "& .MuiInputLabel-shrink.Mui-focused": {
                      color: grey[800],
                    },
                  }}
                  inputRef={ref}
                  aria-label="Search"
                  label="Search"
                  size="small"
                  variant="standard"
                  slotProps={{
                    input: {
                      slotProps: {
                        input: { sx: { marginBottom: "-0.15rem !important" } },
                      },
                      endAdornment: other.value ? (
                        <InputAdornment position="end">
                          <QuickFilterClear
                            edge="end"
                            size="small"
                            aria-label="Clear search"
                            material={{ sx: { marginRight: -0.75 } }}
                          >
                            <Cancel fontSize="small" />
                          </QuickFilterClear>
                        </InputAdornment>
                      ) : (
                        <InputAdornment position="start">
                          <Search fontSize="small" />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              )}
            />
          </QuickFilter>
        </GridPortalWrapper>
      </Portal>
    </>
  );
};

export default SearchBar;
